module.exports = __webpack_public_path__ + "static/media/206-gallery12.81b44e74.jpg";